import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
	selector: 'peps-no-content',
	imports: [],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './no-content.component.html',
})
export class NoContentComponent {

	@Input() text: string = "";
}
